import { memo } from "react"

const IconOutstandingBalance = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="31" height="32" viewBox="0 0 31 32" fill="none">
      <rect y="0.666016" width="30.6667" height="30.6667" rx="7.11111" fill="#7B78E1" fill-opacity="0.3" />
      <path
        d="M14.5 19.25H8.58333C7.70833 19.25 7 18.5417 7 17.6667V10.0833C7 9.20833 7.70833 8.5 8.58333 8.5H21.25C22.125 8.5 22.8333 9.20833 22.8333 10.0833V14.3333"
        stroke="#002C98"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.316 12.6425C17.0885 13.415 17.0885 14.6683 16.316 15.4417C15.5435 16.2142 14.2902 16.2142 13.5169 15.4417C12.7444 14.6692 12.7444 13.4158 13.5169 12.6425C14.2902 11.8692 15.5435 11.8692 16.316 12.6425"
        stroke="#002C98"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20.3333 23.5007C18.4925 23.5007 17 22.0082 17 20.1673C17 18.3265 18.4925 16.834 20.3333 16.834C22.175 16.834 23.6667 18.3265 23.6667 20.1673C23.6667 22.0082 22.175 23.5007 20.3333 23.5007"
        stroke="#002C98"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.3333 16.8327H9.5"
        stroke="#002C98"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20.3333 11.0007H19.5"
        stroke="#002C98"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21.8149 19.4258L19.9632 21.2774L18.8516 20.1666"
        stroke="#002C98"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}

export default memo(IconOutstandingBalance)
